function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.85728 7.42871V1.42871H15.143V7.42871M4.85728 15.143H3.143C2.68834 15.143 2.2523 14.9624 1.93081 14.6409C1.60932 14.3194 1.42871 13.8834 1.42871 13.4287V9.143C1.42871 8.68834 1.60932 8.2523 1.93081 7.93081C2.2523 7.60932 2.68834 7.42871 3.143 7.42871H16.8573C17.3119 7.42871 17.748 7.60932 18.0695 7.93081C18.391 8.2523 18.5716 8.68834 18.5716 9.143V13.4287C18.5716 13.8834 18.391 14.3194 18.0695 14.6409C17.748 14.9624 17.3119 15.143 16.8573 15.143H15.143M4.85728 11.7144H15.143V18.5716H4.85728V11.7144Z",
  stroke: "url(#paint0_linear_7368_778)",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_7368_778",
  x1: 10.0001,
  y1: 1.42871,
  x2: 10.0001,
  y2: 18.5716,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#161626"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})));

function SvgBlackPrinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPrinter);
export default __webpack_public_path__ + "static/media/black-printer.1c154972.svg";
export { ForwardRef as ReactComponent };